import { handleActions } from 'redux-actions'
import {
  USER_RESET_PASSWORD,
} from '@/store/actions/user'
import {
  NOT_REQUESTED,
  IDLE,
  PENDING,
  ERROR,
  REQUEST_STATUSES,
} from '@/constants/requests'


const initialState = {
  errors: [],
  data: {},
  status: REQUEST_STATUSES[NOT_REQUESTED],
}

export const reducer = handleActions(
  {
    [USER_RESET_PASSWORD.BEGIN]: () => ({
      ...initialState,
      status: REQUEST_STATUSES[PENDING],
    }),
    [USER_RESET_PASSWORD.SUCCESS]: (state, { payload: { data } }) => ({
      ...state,
      data,
      status: REQUEST_STATUSES[IDLE],
    }),
    [USER_RESET_PASSWORD.ERROR]: (state, { payload: { errors } }) => ({
      ...state,
      errors,
      status: REQUEST_STATUSES[ERROR],
    }),
  },
  initialState,
)

export default reducer
